export const FEATURE_FLAGS = {
  EXEMPLO: "frontend_exemplo",
  ACCOUNT_MANAGEMENT: "frontend_account_management",
};

